//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';
import { useSelector } from 'react-redux';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Paper, Card, CardHeader, CardContent, Box } from '@mui/material';
import { grey } from '@mui/material/colors';

// === COMPONENTS ===
import { Thumbnail } from './components/Thumbnail/Thumbnail.jsx';

//#endregion

export function ThumbPanel({documents, images}) {

  //#region [Main] store
  // const documents = useSelector((state) => state.documents);

  const theme = useTheme();
  const _styles = {
    thumb_paper: {
      gridColumn: 'span 2',
      // margin   : theme.spacing(1),
      // padding  : 0,
      overflow : 'auto'     ,
      position : 'relative' ,
      height   : '100%',
      width    : '100%',
      boxShadow: 0,
      backgroundColor: theme.palette.panel.main,
    },
    header: {
      boxShadow: '-0.5em 0 0 0.01em' + theme.palette.primary.main,
      padding: '1rem',
      marginBottom: '0.5em',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      height: '4rem',
      zIndex: 5,
    },
    pages: {
      margin : 0,
      // display: 'flex',
      justifyContent: 'start',
    },
    document: {
      borderTop       : `5px solid ${theme.palette.primary.main}`,
      borderRadius    : 0,
      boxShadow       : 'none',
      // backgroundColor : theme.palette.default,
      paddingBottom   : theme.spacing(2),
      '&:last-child'  : {
        paddingBottom: theme.spacing(4),
      },
    },
    container: {
      // display  : isVisible ? '' : 'none',
      // borderTop: `5px solid ${theme.palette.primary.main}`,
      borderRadius: '0.5rem',
      boxShadow: '2',
      // height: is_open ? 'calc( 100% - 12rem )' : '4rem',
      width: '100%',
      margin: 0,
      backgroundColor: theme.palette.background.secondary[theme.palette.mode], 
    },
    document_container: {
      height: '100%', width: '100%', overflow: 'auto',
      // backgroundColor: grey[300],

      scrollbarWidth: "none", // Hide the scrollbar for firefox
      '&::-webkit-scrollbar': {
          display: 'none', // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
      },
      '&-ms-overflow-style:': {
          display: 'none', // Hide the scrollbar for IE
      },
    }
  }
  const _styles2 = {
    container: {
      // display  : isVisible ? '' : 'none',
      // borderTop: `5px solid ${theme.palette.primary.main}`,
      borderRadius: '0.5rem',
      boxShadow: '2',
      // height: is_open ? 'calc( 100% - 12rem )' : '4rem',
      width: '100%',
      margin: 0,
      marginTop: '1rem',
    },
    header: {
      boxShadow: '-0.5em 0 0.5em 0.01em' + theme.palette.primary.main,
      // padding: '1rem',
      // marginBottom: '0.5em',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      height: '4rem',
      zIndex: 5,
    },
    content: {
      // display: is_open ? '' : 'none',
      margin: 0,
      padding: '1rem',
      height: 'calc( 100% - 4rem )',
      width: '100%',
      overflowY: 'auto',
    },
    blocks: {
      height: '100%',
      width: '100%',
      overflowY: 'auto',
    }
  }

  //#endregion

  //-----------------------------------------------------------------
  function displayHeader( title ) {
    //-----------------------------------------------------------------
    return (
      <CardHeader sx={_styles.header} title={title} />
    );
  }

  //-----------------------------------------------------------------
  function displayPages(doc_id) {
    //-----------------------------------------------------------------
    const doc = documents.items[doc_id];
    const thumbs = doc.order.map( id => <Thumbnail key={id} id={id} image={images.items[id]} /> );

    return (
      <CardContent sx={_styles.pages}>
        {thumbs}
      </CardContent>
    );
  }

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const result = [];
    for (let id of documents.order) {
      const doc = documents.items[id];
      result.push(
        <Card key={id} sx={_styles.container}>
          { displayHeader( doc.name ) }
          <Box sx={{height: '100%'}}>
            { displayPages ( id ) }
          </Box>
        </Card>
      );
    }
    return (    
      <Paper sx={_styles.thumb_paper}>
        <Box sx={_styles.document_container}>
          {result}
        </Box>
      </Paper>
    )
  }

  return display();
}
